import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const Unassigned_tickets = createApi({
  reducerPath: "unassigned_tickets",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    unassigned: builder.query({
      query: ({
        currentPage,
        selectedUnassignedFilters1,
        isFilterOn,
        task_source,
        pageSize,
        selectedTeam,
      }) => {
        let teamId = localStorage.getItem("teamId");
        let baseUrl = `v1/tickets/activity-tasks/?task_type=unassigned_ticket&task_source=${task_source}&page_size=${pageSize}&team=${teamId}`;

        if (!isFilterOn) {
          baseUrl += `&page=${currentPage}`;
        }

        const filterParams = isFilterOn
          ? `&filters=on${getFilterParams(selectedUnassignedFilters1)}`
          : "";

        return `${baseUrl}${filterParams}`;
      },
    }),
  }),
});

export const { useUnassignedQuery } = Unassigned_tickets;

function getFilterParams(selectedFilterAndValue2: object) {
  const filterParams = Object.entries(selectedFilterAndValue2)
    .filter(([key, value]) => value !== "")
    .map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return filterParams ? `&${filterParams}` : "";
}
